const getters = {
  sidebar: (state) => state.sidebar,
  templates: (state) => state.templates,
  moduleName: (state) => state.moduleName,
  token: (state) => state.user.token,
  userName: (state) => state.user.name,
  user: (state) => state.user.user,
  codes: (state) => state.user.resourceCode,
  roles: (state) => state.user.roles,
  readModle: (state) => state.user.readModle,
  noAsyncGetToken: (state) => state.user.noAsyncGetToken,
  addRouters: (state) => state.permission.addRouters,
  routers: (state) => state.permission.routers,
  menuConfig: (state) => state.config.menuConfig,
  globalConfig: (state) => state.config.globalConfig,
  isVisable: (state) => state.config.isVisable,
  componentName: (state) => state.config.componentName,
  componentData: (state) => state.config.componentData,
  componentOpts: (state) => state.config.componentOpts,
  dialogMenuVisible: (state) => state.config.dialogMenuVisible,
  xExtractState: (state) => state.xExtract,
  menuRouters: (state) => state.$menu
};
export default getters;
